import { useFormatter, DateTimeFormatOptions, createFormatter } from "next-intl";

interface FormatDateProps {
  utcDate: Date;
  monthFormat?: "long" | "short" | "numeric" | "2-digit" | "narrow";
  yearFormat?: "numeric" | "2-digit";
  dayFormat?: "2-digit" | "numeric";
  formatter: ReturnType<typeof useFormatter> | ReturnType<typeof createFormatter>;
}

const formatDate = ({
  utcDate,
  monthFormat = "long",
  dayFormat = "2-digit",
  yearFormat,
  formatter
}: FormatDateProps) => {
  const options: DateTimeFormatOptions = {
    day: dayFormat,
    month: monthFormat,
    timeZone: "UTC"
  };

  if (yearFormat) {
    options.year = yearFormat;
  }

  return formatter?.dateTime(utcDate, options);
};

export type { FormatDateProps };

export default formatDate;
